import React, { useEffect, useState } from "react";
import "../styles/Holiday.css";
import HolidayUserDetails from "./holiday_user_details.js";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Loading from "../helpers/loading_component.js";
import { secretKey } from "../.././data";

const MySwal = withReactContent(Swal2);

const AddDeskReservation = (props) => {
  const [weekName, setWeekName] = useState("");
  const [dateC, setDateC] = useState(new Date());
  const [deskRes, setDeskRes] = useState([]);
  const [holidaysData, setHolidaysData] = useState([]);
  const [loading, setLoading] = useState(true);

  const addDays = (date, days) => {
    var dateN = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    dateN.setDate(dateN.getDate() + days);
    return dateN;
  };

  const subDays = (date, days) => {
    var dateN = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    dateN.setDate(dateN.getDate() - days);
    return dateN;
  };

  const getDateOfWeek = (w, y) => {
    var d = 1 + (w - 1) * 7;

    if (new Date(y, 0, d).getFullYear() === 2023) {
      return new Date(y, 0, d + 1);
    } else if (new Date(y, 0, d).getFullYear() === 2024) {
      return new Date(y, 0, d);
    } else if (y === 2025) {
      return subDays(new Date(y, 0, d), 2);
    } else {
      return new Date(y, 0, d);
    }
  };

  const getDateOfWeek1 = (w, y) => {
    var d = 1 + (w - 2) * 7;

    return new Date(y, 0, d + 5);
  };

  const createMonthSet = () => {
    var date = new Date(dateC);

    var dayStart = new Date(date).getDay();
    var daysToSubStart = dayStart === 0 ? 6 : dayStart - 1;
    var startWeekDate = subDays(date, daysToSubStart);
    var endWeekDate = addDays(startWeekDate, 27);

    var beginCounter = startWeekDate;
    var daysArray = [];
    while (beginCounter >= startWeekDate && beginCounter <= endWeekDate) {
      daysArray.push(
        `${beginCounter.getFullYear()}-${
          beginCounter.getMonth() + 1 < 10
            ? "0" + (beginCounter.getMonth() + 1)
            : beginCounter.getMonth() + 1
        }-${
          beginCounter.getDate() < 10
            ? "0" + beginCounter.getDate()
            : beginCounter.getDate()
        }`
      );
      beginCounter.setDate(beginCounter.getDate() + 1);
    }

    return daysArray;
  };

  const getRemote = (date) => {
    if (
      new Date(date).getDay() === 6 ||
      new Date(date).getDay() === 0 ||
      checkFreeDay(date)
    ) {
      return [];
    }
    var holidays = holidaysData.filter(
      (el) =>
        date >= new Date(el.date_from) &&
        date <= new Date(el.date_to) &&
        el.type === "remote"
    );
    return holidays;
  };

  const checkFreeDay = (date) => {
    var free = props.freeDaysData.filter(
      (el) => new Date(date) === new Date(el)
    );
    if (free.length > 0) {
      return true;
    }
    return false;
  };

  const fetchHolidays = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getHolidays", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setHolidaysData(data);
      })
      .catch((error) => {});
  };

  const fetchDesksRes = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getDesksRes", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setDeskRes(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchHolidays();
    fetchDesksRes();
  };

  useEffect(() => {
    getData();
    var date = dateC;
    var startDate = new Date(new Date().getFullYear(), 0, 1);
    var days = Math.floor((new Date(date) - startDate) / (24 * 60 * 60 * 1000));
    var weekNumber = Math.ceil(days / 7);
    setWeekName("Tydzień " + (weekNumber + 1));
  }, []);

  const checkIfexistRemote = (date) => {
    var data = holidaysData.filter(
      (el) =>
        el.date_from === date &&
        el.user === props.user.name &&
        el.type === "remote"
    );

    return data.length > 0 ? true : false;
  };

  const checkIfexistRemoteAdmin = (date, user) => {
    var data = holidaysData.filter(
      (el) => el.date_from === date && el.user === user && el.type === "remote"
    );

    return data.length > 0 ? true : false;
  };

  const addRemote1 = (e) => {
    setLoading(true);
    if (+props.user.urlopyAdmin === 1) {
      var model = [];

      props.users
        .filter((el) => +el.urlopyZdalna === 1)
        .map((element) => {
          model[element.name] = element.name;
        });

      MySwal.fire({
        title: "Wybierz pracownika",
        input: "select",
        inputOptions: model,
        inputPlaceholder: "wybierz pracownika",
        showCancelButton: true,
        cancelButtonText: "Anuluj",
        inputValidator: function (value) {
          return new Promise(function (resolve, reject) {
            if (value !== "") {
              resolve();
            } else {
              resolve("musisz wybrać pracownika");
            }
          });
        },
      }).then(function (result) {
        if (result.isConfirmed) {
          addRemoteAdmin(e.target.value, result.value);
        }
      });
    } else {
      addRemote(e.target.value);
    }
  };

  const addRemote = async (date) => {
    setLoading(true);
    if (!checkIfexistRemote(date)) {
      if (!checkIfexistDeskRes(date)) {
        var body = {
          date_from: date,
          date_to: date,
          user: props.user.name,
          status: "ACCEPTED",
          date_added: new Date(),
          date_accepted: new Date(),
          type: "remote",
        };

        fetch("https://apidevkppp.ftpeople.pl/addHoliday", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});

        MySwal.fire({
          icon: "success",
          title: "Dodano",
          text: "pracę zdalną",
        }).then((result) => {
          getData();
        });
      } else {
        MySwal.fire({
          icon: "error",
          title: "Istnieje",
          text: "rezerwacja biurka dla tego pracownika, w tym dniu",
        }).then((result) => {});
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Istnieje",
        text: "praca zdalna dla tego pracownika, w tym dniu",
      }).then((result) => {});
    }
  };

  const addRemoteAdmin = async (date, user) => {
    setLoading(true);
    if (!checkIfexistRemoteAdmin(date, user)) {
      if (!checkIfexistDeskResAdmin(date, user)) {
        var body = {
          date_from: date,
          date_to: date,
          user: user,
          status: "ACCEPTED",
          date_added: new Date(),
          date_accepted: new Date(),
          type: "remote",
        };

        fetch("https://apidevkppp.ftpeople.pl/addHoliday", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});

        MySwal.fire({
          icon: "success",
          title: "Dodano",
          text: "pracę zdalną",
        }).then((result) => {
          getData();
        });
      } else {
        MySwal.fire({
          icon: "error",
          title: "Istnieje",
          text: "rezerwacja biurka dla tego pracownika, w tym dniu",
        }).then((result) => {});
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Istnieje",
        text: "praca zdalna dla tego pracownika, w tym dniu",
      }).then((result) => {});
    }
  };

  const checkIfexistDeskRes = (date) => {
    var data = deskRes.filter(
      (el) => el.date === date && el.name === props.user.name
    );

    return data.length > 0 ? true : false;
  };

  const checkIfexistDeskResAdmin = (date, user) => {
    var data = deskRes.filter((el) => el.date === date && el.name === user);

    return data.length > 0 ? true : false;
  };

  const addDeskRes1 = (e) => {
    if (+props.user.urlopyAdmin === 1) {
      var model = [];

      props.users
        .filter((el) => +el.urlopyZdalna === 1)
        .map((element) => {
          model[element.name] = element.name;
        });

      MySwal.fire({
        title: "Wybierz pracownika",
        input: "select",
        inputOptions: model,
        inputPlaceholder: "wybierz pracownika",
        showCancelButton: true,
        cancelButtonText: "Anuluj",
        inputValidator: function (value) {
          return new Promise(function (resolve, reject) {
            if (value !== "") {
              resolve();
            } else {
              resolve("musisz wybrać pracownika");
            }
          });
        },
      }).then(function (result) {
        if (result.isConfirmed) {
          addDeskResAdmin(e.target.value, "1", result.value);
        }
      });
    } else {
      addDeskRes(e.target.value, "1");
    }
  };

  const addDeskRes2 = (e) => {
    if (+props.user.urlopyAdmin === 1) {
      var model = [];

      props.users
        .filter((el) => +el.urlopyZdalna === 1)
        .map((element) => {
          model[element.name] = element.name;
        });

      MySwal.fire({
        title: "Wybierz pracownika",
        input: "select",
        inputOptions: model,
        inputPlaceholder: "wybierz pracownika",
        showCancelButton: true,
        cancelButtonText: "Anuluj",
        inputValidator: function (value) {
          return new Promise(function (resolve, reject) {
            if (value !== "") {
              resolve();
            } else {
              resolve("musisz wybrać pracownika");
            }
          });
        },
      }).then(function (result) {
        if (result.isConfirmed) {
          addDeskResAdmin(e.target.value, "2", result.value);
        }
      });
    } else {
      addDeskRes(e.target.value, "2");
    }
  };

  const addDeskRes3 = (e) => {
    if (+props.user.urlopyAdmin === 1) {
      var model = [];

      props.users
        .filter((el) => +el.urlopyZdalna === 1)
        .map((element) => {
          model[element.name] = element.name;
        });

      MySwal.fire({
        title: "Wybierz pracownika",
        input: "select",
        inputOptions: model,
        inputPlaceholder: "wybierz pracownika",
        showCancelButton: true,
        cancelButtonText: "Anuluj",
        inputValidator: function (value) {
          return new Promise(function (resolve, reject) {
            if (value !== "") {
              resolve();
            } else {
              resolve("musisz wybrać pracownika");
            }
          });
        },
      }).then(function (result) {
        if (result.isConfirmed) {
          addDeskResAdmin(e.target.value, "3", result.value);
        }
      });
    } else {
      addDeskRes(e.target.value, "3");
    }
  };

  const addDeskRes4 = (e) => {
    if (+props.user.urlopyAdmin === 1) {
      var model = [];

      props.users
        .filter((el) => +el.urlopyZdalna === 1)
        .map((element) => {
          model[element.name] = element.name;
        });

      MySwal.fire({
        title: "Wybierz pracownika",
        input: "select",
        inputOptions: model,
        inputPlaceholder: "wybierz pracownika",
        showCancelButton: true,
        cancelButtonText: "Anuluj",
        inputValidator: function (value) {
          return new Promise(function (resolve, reject) {
            if (value !== "") {
              resolve();
            } else {
              resolve("musisz wybrać pracownika");
            }
          });
        },
      }).then(function (result) {
        if (result.isConfirmed) {
          addDeskResAdmin(e.target.value, "4", result.value);
        }
      });
    } else {
      addDeskRes(e.target.value, "4");
    }
  };

  const addDeskRes5 = (e) => {
    if (+props.user.urlopyAdmin === 1) {
      var model = [];

      props.users
        .filter((el) => +el.urlopyZdalna === 1)
        .map((element) => {
          model[element.name] = element.name;
        });

      MySwal.fire({
        title: "Wybierz pracownika",
        input: "select",
        inputOptions: model,
        inputPlaceholder: "wybierz pracownika",
        showCancelButton: true,
        cancelButtonText: "Anuluj",
        inputValidator: function (value) {
          return new Promise(function (resolve, reject) {
            if (value !== "") {
              resolve();
            } else {
              resolve("musisz wybrać pracownika");
            }
          });
        },
      }).then(function (result) {
        if (result.isConfirmed) {
          addDeskResAdmin(e.target.value, "5", result.value);
        }
      });
    } else {
      addDeskRes(e.target.value, "5");
    }
  };

  const addDeskRes6 = (e) => {
    if (+props.user.urlopyAdmin === 1) {
      var model = [];

      props.users
        .filter((el) => +el.urlopyZdalna === 1)
        .map((element) => {
          model[element.name] = element.name;
        });

      MySwal.fire({
        title: "Wybierz pracownika",
        input: "select",
        inputOptions: model,
        inputPlaceholder: "wybierz pracownika",
        showCancelButton: true,
        cancelButtonText: "Anuluj",
        inputValidator: function (value) {
          return new Promise(function (resolve, reject) {
            if (value !== "") {
              resolve();
            } else {
              resolve("musisz wybrać pracownika");
            }
          });
        },
      }).then(function (result) {
        if (result.isConfirmed) {
          addDeskResAdmin(e.target.value, "6", result.value);
        }
      });
    } else {
      addDeskRes(e.target.value, "6");
    }
  };

  const addDeskRes = (date, name) => {
    setLoading(true);
    if (!checkIfexistDeskRes(date)) {
      if (!checkIfexistRemote(date)) {
        var body = {
          date: date,
          name: props.user.name,
          desk: name,
        };

        fetch("https://apidevkppp.ftpeople.pl/addDeskRes", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});
        MySwal.fire({
          icon: "success",
          title: "Dodano",
          text: "rezerwację biurka",
        }).then((result) => {
          getData();
        });
      } else {
        MySwal.fire({
          icon: "error",
          title: "Istnieje",
          text: "praca zdalna dla tego pracownika, w tym dniu",
        }).then((result) => {});
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Istnieje",
        text: "rezerwacja biurka dla tego pracownika, w tym dniu",
      }).then((result) => {});
    }
  };

  const addDeskResAdmin = async (date, name, user) => {
    setLoading(true);
    if (!checkIfexistDeskResAdmin(date, user)) {
      if (!checkIfexistRemoteAdmin(date, user)) {
        var body = {
          date: date,
          name: user,
          desk: name,
        };

        await fetch("https://apidevkppp.ftpeople.pl/addDeskRes", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});

        MySwal.fire({
          icon: "success",
          title: "Dodano",
          text: "rezerwację biurka",
        }).then((result) => {
          getData();
        });
      } else {
        MySwal.fire({
          icon: "error",
          title: "Istnieje",
          text: "praca zdalna dla tego pracownika, w tym dniu",
        }).then((result) => {});
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Istnieje",
        text: "rezerwacja biurka dla tego pracownika, w tym dniu",
      }).then((result) => {});
    }
  };

  const delDeskRes = async (e) => {
    setLoading(true);
    var body = {
      id: e.target.value,
    };

    fetch("https://apidevkppp.ftpeople.pl/deleteDeskRes", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    MySwal.fire({
      icon: "success",
      title: "Usunięto",
      text: "rezerwację biurka",
    }).then((result) => {
      getData();
    });
  };

  const removeRemote = async (e) => {
    setLoading(true);

    var body = {
      id: e.currentTarget.value,
    };

    fetch("https://apidevkppp.ftpeople.pl/deleteHoliday", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    MySwal.fire({
      icon: "success",
      title: "Usunięto",
      text: "pracę zdalną",
    }).then((result) => {
      getData();
    });
  };

  const checkRes = (desk, date) => {
    if (deskRes === undefined) {
      return "";
    } else {
      try {
        var name = deskRes.filter(
          (el) => el.desk === desk && el.date === date
        )[0].name;
      } catch (error) {
        var name = "";
      }
      return name === undefined ? "" : name;
    }
  };

  const checkResId = (desk, date) => {
    if (deskRes === undefined) {
      return "";
    } else {
      try {
        var name = deskRes.filter(
          (el) => el.desk === desk && el.date === date
        )[0].id;
      } catch (error) {
        var name = "";
      }
      return name === undefined ? "" : name;
    }
  };

  const calendarWeekNew = (
    <>
      <div className="rowCalendar">
        {createMonthSet().map((el) => (
          <>
            <div
              id="adrCellCalendarWeek"
              key={el}
              className="cellCalendarWeek"
              style={{ height: "85vh" }}
            >
              <div id={"cb" + new Date(el).getDate()} className="odrWeekBox">
                {new Date(el).getDay() === 0 || new Date(el).getDay() === 6 ? (
                  <>
                    <div
                      style={{
                        fontWeight: "600",
                        width: "100%",
                        textAlign: "center",
                      }}
                    >
                      WEEKEND
                    </div>
                  </>
                ) : (
                  <>
                    <div className="weekSpecialBox">
                      BIURKA
                      <div className="sepADR"></div>
                      {props.desksData.map((el2) => (
                        <>
                          <div
                            className="officeDeskBox"
                            value={el2.name}
                            style={{ minHeight: "5vh", paddingBottom: "5px" }}
                          >
                            💼 {el2.name}
                            {checkRes(el2.name, el).length > 0 ? (
                              <>
                                <div
                                  style={{
                                    fontSize: "0.6vw",
                                    fontWeight: "300",
                                  }}
                                >
                                  {checkRes(el2.name, el)}
                                </div>
                                {+props.user.urlopyAdmin === 1 ||
                                checkRes(el2.name, el) === props.user.name ? (
                                  <button
                                    style={{
                                      width: "70%",
                                      cursor: "pointer",
                                      textAlign: "center",
                                      backgroundColor: "white",
                                      color: "black",
                                      minHeight: "1vh",
                                      padding: "0",
                                      marginTop: "5px",
                                    }}
                                    id="monthLink"
                                    className="caseLink"
                                    value={checkResId(el2.name, el)}
                                    onClick={delDeskRes}
                                  >
                                    USUŃ
                                  </button>
                                ) : (
                                  ""
                                )}
                              </>
                            ) : (
                              <>
                                {el2.name === "1" ? (
                                  <>
                                    <button
                                      style={{
                                        width: "70%",
                                        cursor: "pointer",
                                        textAlign: "center",
                                        backgroundColor: "white",
                                        color: "black",
                                      }}
                                      id="monthLink"
                                      className="caseLink"
                                      value={el}
                                      onClick={addDeskRes1}
                                    >
                                      REZERWUJ
                                    </button>{" "}
                                  </>
                                ) : el2.name === "2" ? (
                                  <>
                                    <button
                                      style={{
                                        width: "70%",
                                        cursor: "pointer",
                                        textAlign: "center",
                                        backgroundColor: "white",
                                        color: "black",
                                      }}
                                      id="monthLink"
                                      className="caseLink"
                                      value={el}
                                      onClick={addDeskRes2}
                                    >
                                      REZERWUJ
                                    </button>{" "}
                                  </>
                                ) : el2.name === "3" ? (
                                  <>
                                    <button
                                      style={{
                                        width: "70%",
                                        cursor: "pointer",
                                        textAlign: "center",
                                        backgroundColor: "white",
                                        color: "black",
                                      }}
                                      id="monthLink"
                                      className="caseLink"
                                      value={el}
                                      onClick={addDeskRes3}
                                    >
                                      REZERWUJ
                                    </button>{" "}
                                  </>
                                ) : el2.name === "4" ? (
                                  <>
                                    <button
                                      style={{
                                        width: "70%",
                                        cursor: "pointer",
                                        textAlign: "center",
                                        backgroundColor: "white",
                                        color: "black",
                                      }}
                                      id="monthLink"
                                      className="caseLink"
                                      value={el}
                                      onClick={addDeskRes4}
                                    >
                                      REZERWUJ
                                    </button>{" "}
                                  </>
                                ) : el2.name === "5" ? (
                                  <>
                                    <button
                                      style={{
                                        width: "70%",
                                        cursor: "pointer",
                                        textAlign: "center",
                                        backgroundColor: "white",
                                        color: "black",
                                      }}
                                      id="monthLink"
                                      className="caseLink"
                                      value={el}
                                      onClick={addDeskRes5}
                                    >
                                      REZERWUJ
                                    </button>{" "}
                                  </>
                                ) : el2.name === "6" ? (
                                  <>
                                    <button
                                      style={{
                                        width: "70%",
                                        cursor: "pointer",
                                        textAlign: "center",
                                        backgroundColor: "white",
                                        color: "black",
                                      }}
                                      id="monthLink"
                                      className="caseLink"
                                      value={el}
                                      onClick={addDeskRes6}
                                    >
                                      REZERWUJ
                                    </button>{" "}
                                  </>
                                ) : (
                                  ""
                                )}
                              </>
                            )}
                          </div>
                        </>
                      ))}
                    </div>
                    <span
                      style={{
                        width: "100%",
                        textAlign: "center",
                        fontWeight: "600",
                      }}
                    >
                      PRACA ZDALNA
                    </span>
                    <div
                      id="remoteScroll"
                      className="weekSpecialBox"
                      style={{ height: "2vh", minHeight: "11vh" }}
                    >
                      <div className="sepADR"></div>
                      {getRemote(new Date(el)).map((el5) => (
                        <>
                          {+props.user.urlopyAdmin === 1 ||
                          el5.user === props.user.name ? (
                            <>
                              <div className="remoteFlex">
                                <>
                                  <button
                                    key={el5.id}
                                    style={{
                                      width: "50%",
                                      marginBottom: "1vh",
                                      cursor: "default",
                                      textAlign: "center",
                                      backgroundColor: "transparent",
                                      color: "black",
                                    }}
                                    id="monthLink"
                                    className="caseLink"
                                    value={el5.id}
                                  >
                                    <div className="titleBox">
                                      <div
                                        id="titleHoliday"
                                        className="titleBox_col1"
                                        style={{
                                          width: "100%",
                                          textAlign: "center",
                                          fontSize: "0.5vw",
                                        }}
                                      >
                                        {el5.user}
                                      </div>
                                    </div>
                                  </button>{" "}
                                </>
                                <>
                                  <button
                                    key={el5.id}
                                    style={{
                                      cursor: "pointer",
                                      width: "50%",
                                      marginBottom: "1vh",
                                      textAlign: "center",
                                      backgroundColor: "transparent",
                                      color: "black",
                                    }}
                                    id="monthLink"
                                    className="caseLink"
                                    value={el5.id}
                                    onClick={removeRemote}
                                  >
                                    <div className="titleBox">
                                      <div
                                        id="titleHoliday"
                                        className="titleBox_col1"
                                        style={{
                                          width: "100%",
                                          textAlign: "center",
                                          fontSize: "0.5vw",
                                        }}
                                      >
                                        USUŃ
                                      </div>
                                    </div>
                                  </button>{" "}
                                </>
                              </div>
                            </>
                          ) : (
                            <>
                              <button
                                key={el5.id}
                                style={{
                                  marginBottom: "1vh",
                                  cursor: "default",
                                  textAlign: "center",
                                  backgroundColor: "transparent",
                                  color: "black",
                                }}
                                id="monthLink"
                                className="caseLink"
                                value={el5.id}
                              >
                                <div className="titleBox">
                                  <div
                                    id="titleHoliday"
                                    className="titleBox_col1"
                                    style={{
                                      width: "100%",
                                      textAlign: "center",
                                      fontSize: "0.5vw",
                                    }}
                                  >
                                    {el5.user}
                                  </div>
                                </div>
                              </button>{" "}
                            </>
                          )}
                        </>
                      ))}
                    </div>
                    <div className="weekSpecialBoxA">
                      {getRemote(new Date(el)).length > 3 ? (
                        <button
                          id="adrBC"
                          style={{ bottom: "35px" }}
                          value={new Date(el).getDate()}
                          className="moreButtonCalendar"
                        >
                          ▼
                        </button>
                      ) : (
                        ""
                      )}
                      <>
                        <button
                          style={{
                            zIndex: "999999",
                            cursor: "pointer",
                            textAlign: "center",
                            backgroundColor: "white",
                            color: "black",
                            marginTop: "5px",
                          }}
                          id="monthLink"
                          className="caseLink"
                          value={el}
                          onClick={addRemote1}
                        >
                          DODAJ PRACĘ ZDALNĄ
                        </button>{" "}
                      </>
                    </div>
                  </>
                )}
              </div>
              <span className="cellDayNumber">{el}</span>
            </div>
          </>
        ))}
      </div>
    </>
  );

  return (
    <>
      <div className="mainContainerHolidayPopUp">
        {loading ? (
          <Loading />
        ) : (
          <>
            <div style={{ width: "100%" }} className="closeBox">
              <button className="closeClientButton" onClick={props.close}>
                X
              </button>
            </div>

            <div style={{ fontWeight: "600" }}>
              REZERWACJA BIUREK / PRACA ZDALNA
            </div>
            {calendarWeekNew}
          </>
        )}
      </div>
    </>
  );
};

export default AddDeskReservation;
